import * as clone from 'clone';

import { CreateShiftsDTO } from 'src/app/types/dto';

import { CreateShiftsForm, InvitedNurse } from '../types/forms';

export class CreateShiftsAdapter {
  private _facilityId: string;
  private _form: CreateShiftsForm;

  private _dto: CreateShiftsDTO;
  private _invitedNurse: InvitedNurse

  constructor(form: CreateShiftsForm, facilityId: string, invitedNurse: InvitedNurse) {
    this._facilityId = facilityId;
    this._invitedNurse = invitedNurse;
    this._form = clone(form);
  }

  private _adaptDto() {
    return {
      facility: this._facilityId,
      ...(this._invitedNurse ? {invitedNurse: this._invitedNurse} : {}),
      shifts: this._form.map((f) => ({
        date: f.date,
        license: f.license,
        rate: f.rate,
        shiftTemplate: f.shiftTemplate,
        slots: f.slots,
        shiftTemplateDefinition: f.shiftTemplateDefinition,
        ...(!f.isInstaShyft ? {autoConfirmGroup: f.autoConfirmGroup} : {}),
        ...(f.isInstaShyft ? {isInstaShyft: f.isInstaShyft} : {}),
        ...(f.description ? {description: f.description} : {}),
      })),
    } as CreateShiftsDTO;
  }

  get dto() {
    if (!this._dto) this._dto = this._adaptDto();

    return this._dto;
  }
}
